import request from '@/utils/request';

// 设备报表
export const getDeptCusPriceStatistics = (params: any) =>
  request({
    url: 'StatisticsDeptPrice/price',
    method: 'get',
    params
  });

// 导出excel 设备列表
export const exportDeptCusPriceStatistics = (params: any) =>
  request({
    url: 'StatisticsDeptPrice/export',
    method: 'get',
    params
  });
